<template>
    <div class="main-body">
        <h2>{{ $strings('spsite/spapp/title') }}</h2>
        <div class="action-bar">
            <div class="add-wrapper">
                <el-button size="small" type="primary" @click="onCreate">{{ $strings('word/create') }}</el-button>
            </div>
            <div class="filter-wrapper">
                <el-form :inline="true" :model="formFilter" class="demo-form-inline" ref="filter">
                    <el-form-item label="">
                        <FilterSp v-model="formFilter.sp_id" @load="onLoadSp" class="max-width-120"/>
                    </el-form-item>
                    <el-form-item label="">
                        <FilterCp v-model="formFilter.cp_id" @load="onLoadCp" class="max-width-120"/>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onFilter" size="small">{{
                                $strings('word/query')
                            }}
                        </el-button>
                        <el-button @click="onReset" size="small">{{ $strings('word/reset') }}</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="data-area">
            <el-table
                v-loading="loading"
                border
                :data="tableData"
                :row-class-name="rowClassName"
                style="width: 100%">
                <el-table-column type="expand" label="∷" fixed>
                    <template slot-scope="scope">
                        <ul>
                            <li>AppID: {{ scope.row.app_id }}</li>
                            <li>AppToken: {{ scope.row.app_token }}</li>
                        </ul>
                    </template>
                </el-table-column>
                <el-table-column prop="sp_id" :label="$strings('word/sp_id')" width="120" fixed>
                    <template slot-scope="scope"><span class="code-text">{{ scope.row.sp_id }}</span></template>
                </el-table-column>
                <el-table-column prop="sp_name" :label="$strings('word/sp_name')" width="120">
                    <template slot-scope="scope">{{ mapping.sps[scope.row.sp_id] }}</template>
                </el-table-column>
                <el-table-column prop="link_id" :label="$strings('word/link_id')" width="120"></el-table-column>
                <el-table-column prop="app_id" :label="$strings('word/app_id')" width="120"></el-table-column>
                <el-table-column prop="app_name" :label="$strings('word/app_name')" width="120"></el-table-column>
                <el-table-column prop="app_status" :label="$strings('word/app_status')" width="100">
                    <template slot-scope="scope">
                        <el-badge is-dot class="item"
                                  :type="scope.row.app_status === appStatus.LIVING ? 'success': 'warning'"></el-badge>
                    </template>
                </el-table-column>
                <el-table-column prop="smpp_host" :label="$strings('word/smpp_host')" width="130"></el-table-column>
                <el-table-column prop="smpp_port" :label="$strings('word/smpp_port')" width="120"></el-table-column>
                <el-table-column prop="smpp_user" :label="$strings('word/smpp_user')" width="120"></el-table-column>
                <el-table-column prop="smpp_pass" :label="$strings('word/smpp_pass')" width="140"></el-table-column>
                <el-table-column prop="smpp_sender" :label="$strings('word/smpp_sender')" width="120"></el-table-column>
                <el-table-column prop="cp_name" :label="$strings('word/cp_name')">
                    <template slot-scope="scope">{{ mapping.cps[scope.row.cp_id] }}</template>
                </el-table-column>
                <el-table-column prop="cp_app_id" :label="$strings('word/bind_cp_app_id')"
                                 width="200"></el-table-column>
                <el-table-column prop="ct_time" label="CreateTime" width="160">
                    <template slot-scope="scope">
                        {{ convertUnixToDate(scope.row.ct_time) }}
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="Remark" width="160"></el-table-column>
                <el-table-column label="Edit" width="160" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="small" @click="onEdit(scope.row)">Edit</el-button>
                        <el-button size="small" @click="onCopy(scope.row)">Copy</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination table-pagination" v-if="!loading && pagination.total > pagination.size">
                <el-pagination background layout="prev, pager, next" :total="pagination.total"
                               :page-size.sync="pagination.size"
                               :current-page.sync="pagination.page"
                               @current-change="refreshData"></el-pagination>
            </div>

        </div>
        <el-dialog
            :title="mode === 'create' ? $strings('word/create') : $strings('word/edit')"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            @closed="onClose"
            width="36%">
            <div>
                <el-form ref="form" :model="editForm" :rules="rules" label-width="90px">
                    <el-divider content-position="left">SP SMPP配置</el-divider>
                    <el-form-item prop="sp_id" v-if="mode==='create'" :label="$strings('word/sp_name')">
                        <FilterSp v-model="editForm.sp_id"/>
                    </el-form-item>
                    <el-form-item prop="smpp_host"
                                  :label="$strings('word/smpp_host')">
                        <el-input v-model.trim="editForm.smpp_host" clearable maxlength="16" show-word-limit
                                  :placeholder="$strings('word/smpp_host')"></el-input>
                    </el-form-item>
                    <el-form-item prop="smpp_port"
                                  :label="$strings('word/smpp_port')">
                        <el-input v-model.trim="editForm.smpp_port" clearable maxlength="5" show-word-limit
                                  :placeholder="$strings('word/smpp_port')"></el-input>
                    </el-form-item>
                    <el-form-item prop="smpp_user"
                                  :label="$strings('word/smpp_user')">
                        <el-input v-model.trim="editForm.smpp_user" clearable maxlength="16" show-word-limit
                                  :placeholder="$strings('word/smpp_user')"></el-input>
                    </el-form-item>
                    <el-form-item prop="smpp_pass"
                                  :label="$strings('word/smpp_pass')">
                        <el-input v-model.trim="editForm.smpp_pass" clearable maxlength="16" show-word-limit
                                  :placeholder="$strings('word/smpp_pass')"></el-input>
                    </el-form-item>
                    <el-form-item prop="smpp_sender"
                                  :label="$strings('word/smpp_sender')">
                        <el-input v-model="editForm.smpp_sender" clearable maxlength="16" show-word-limit
                                  :placeholder="$strings('word/smpp_sender')"></el-input>
                    </el-form-item>
                    <el-divider content-position="left">HTTP 配置</el-divider>
                    <el-form-item prop="account_id" :label="$strings('word/account_id')">
                        <el-input v-model.trim="editForm.account_id" clearable maxlength="36" show-word-limit
                                  :placeholder="$strings('word/account_id')"></el-input>
                    </el-form-item>
                    <el-form-item prop="account_token" :label="$strings('word/account_token')">
                        <el-input v-model.trim="editForm.account_token" clearable maxlength="64" show-word-limit
                                  :placeholder="$strings('word/account_token')" type="textarea"></el-input>
                    </el-form-item>
                    <el-form-item prop="app_id" :label="$strings('word/app_id')">
                        <el-input v-model="editForm.app_id" clearable maxlength="32" show-word-limit
                                  :placeholder="$strings('word/app_id')"></el-input>
                    </el-form-item>
                    <el-form-item prop="app_name" :label="$strings('word/app_name')">
                        <el-input v-model.trim="editForm.app_name" clearable maxlength="32" show-word-limit
                                  :placeholder="$strings('word/app_name')"></el-input>
                    </el-form-item>
                    <el-form-item prop="app_token" :label="$strings('word/app_token')">
                        <el-input v-model.trim="editForm.app_token" clearable maxlength="64" show-word-limit
                                  :placeholder="$strings('word/app_token')" type="textarea"></el-input>
                    </el-form-item>
                    <el-divider content-position="left">其他配置</el-divider>
                    <el-form-item prop="cp_app_id" :label="$strings('word/cp_app_id')">
                        <el-input v-model="editForm.cp_app_id" clearable maxlength="64" show-word-limit
                                  :placeholder="$strings('spsite/spapp/cp_app_id')" disabled></el-input>
                    </el-form-item>
                    <el-form-item :label="$strings('word/tz')">
                        <el-select v-model="editForm.tz">
                            <el-option v-for="(val,idx) in options.tzs" :key="idx" :label="val.label"
                                       :value="val.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$strings('word/remark')">
                        <el-input v-model.trim="editForm.remark" clearable maxlength="24" show-word-limit
                                  :placeholder="$strings('word/remark')" type="textarea"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{ $strings('word/cancel') }}</el-button>
                <el-button type="primary" @click="onSaveEdit()" :loading="saving">{{ $strings('word/confirm') }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {SpSiteSpAppCreate, SpSiteSpAppRead, SpSiteSpAppUpdate} from "@/api/spsite/api";
import {API_STATUS_CODE, APP_STATUS, SP_APP_STATUS, STORAGE_KEY_LOGIN_TZ} from "@/config/config";
import {GetItem} from "@/utils/storage";
import {UnixToDateFull} from "@/utils/time";
import FilterSp from '@/components/filter/sp'
import FilterCp from '@/components/filter/cp'
import {Timezones} from "@/utils/timezone";

export default {
    name: "spsite-sp-app",
    props: ['link_id'],
    components: {FilterSp, FilterCp},
    data() {
        return {
            loading: true,
            saving: false,
            editForm: {},
            formFilter: {},
            tableData: [],
            dialogVisible: false,
            pagination: {total: 0, page: 1, size: 12,},
            rules: {
                sp_id: [
                    {required: true, message: this.$strings('spsite/spapp/error/field_empty'), trigger: 'blur'}
                ],
                app_id: [
                    {required: true, message: this.$strings('spsite/spapp/error/field_empty'), trigger: 'blur'}
                ]
            },
            options: {sps: [], tzs: Timezones},
            appStatus: APP_STATUS,
            mapping: {cps: {}, sps: {}},
            mode: 'create', // create|update|copy
        }
    },
    beforeCreate() {
    },
    mounted() {
        this.prepareData();
        this.refreshData();
    },
    computed: {},
    methods: {
        rowClassName({row}) {
            if (row.app_status === SP_APP_STATUS.PAUSED) {
                return "row-offline"
            }
            return ""
        },
        onLoadSp(sps) {
            this.options.sps = [];
            this.mapping.sps = {};
            sps.forEach(item => {
                this.options.sps.push({label: item.sp_name, value: item.sp_id});
                this.mapping.sps[item.sp_id] = item.sp_name;
            })
        },
        onLoadCp(cps) {
            this.mapping.cps = {};
            cps.forEach((item) => {
                this.mapping.cps[item.cp_id] = item.cp_name;
            });
        },
        convertUnixToDate(ts) {
            let tz = parseInt(GetItem(STORAGE_KEY_LOGIN_TZ))
            return UnixToDateFull(ts, tz);
        },
        onFilter() {
            this.refreshData();
        },
        onReset() {
            this.formFilter = {};
            this.refreshData();
        },
        onClose() {
            this.saving = false
            this.$refs["form"].clearValidate();
        },
        onEdit(row) {
            this.mode = 'edit';
            this.editForm = row;
            this.dialogVisible = true;
        },
        onCopy(row) {
            this.mode = 'copy';
            this.editForm = JSON.parse(JSON.stringify(row));
            this.editForm.cp_app_id = '';
            this.dialogVisible = true;
        },
        onCreate() {
            this.mode = 'create';
            this.editForm = {};
            this.dialogVisible = true;
        },
        prepareData() {

        },
        onSaveEdit() {
            this.saving = true;
            if (this.editForm.smpp_port.length > 0) {
                this.editForm.smpp_port = parseInt(this.editForm.smpp_port);
            }
            let action = this.mode === 'edit' ? SpSiteSpAppUpdate : SpSiteSpAppCreate;
            if (this.mode === 'copy') {
                this.editForm.cp_id = '';
            }
            action(this.editForm).then((resp) => {
                if (resp.data.code === API_STATUS_CODE.SUCCESS) {
                    this.dialogVisible = false;
                    this.mode = '';
                    this.refreshData();
                }
            }).finally(() => {
                this.saving = false;
            });
        },
        refreshData() {
            this.loading = true;
            this.formFilter.size = this.pagination.size;
            this.formFilter.page = this.pagination.page;
            SpSiteSpAppRead(this.formFilter).then((resp) => {
                console.log(resp.data.data);
                this.tableData = resp.data.data.rows;
                this.pagination.total = resp.data.data.total;
            }).finally(() => {
                this.loading = false;
            })
        },
    }
}
</script>

<style scoped lang="scss">
.action-bar {
    display: flex;
    flex-direction: row;

    .filter-wrapper {
        display: flex;
        justify-content: flex-end;
        flex-grow: 1;
    }

    .add-wrapper {
        padding-top: 4px;
    }
}

.table-pagination {
    margin-top: 1em;
    display: flex;
    justify-content: flex-end;
}
</style>